import { faSparkles } from "@fortawesome/pro-solid-svg-icons/faSparkles";
import { useTheme } from "@mui/material";
import * as React from "react";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconAI: React.FC<Omit<MprcIconFaProps, "icon" | "color">> = (props) => {
    const theme = useTheme();
    return <MprcIconFa {...props} icon={faSparkles} style={{ color: theme.palette.ai.main }} />;
};
